import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Layouts
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Auth Components
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ForgotPassword from './components/auth/ForgotPassword';
import PrivateRoute from './components/auth/PrivateRoute';

// Main Components
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Privacy from './components/Privacy';
import Terms from './components/Terms';

// Poll Components
import CreatePoll from './components/polls/CreatePoll';
import PollList from './components/polls/PollList';
import PollDetail from './components/polls/PollDetail';
import VotePage from './components/polls/VotePage';

// Styles
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/about" element={<About />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              
              {/* Public Poll Routes */}
              <Route path="/polls/:pollId/vote" element={<VotePage />} />
              
              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              } />
              <Route path="/polls" element={
                <PrivateRoute>
                  <PollList />
                </PrivateRoute>
              } />
              <Route path="/polls/create" element={
                <PrivateRoute>
                  <CreatePoll />
                </PrivateRoute>
              } />
              <Route path="/polls/:pollId" element={
                <PrivateRoute>
                  <PollDetail />
                </PrivateRoute>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;